import React, { useState } from 'react';
import useBoardStore from '../store/boardStore';
import { exportBoardToJSON, importBoardFromJSON } from '../utils/boardUtils';
import './Toolbar.css';

const Toolbar = () => {
  const { 
    boardId, 
    stickers, 
    connectors, 
    isConnected, 
    isReconnecting, 
    reconnectAttempts, 
    maxReconnectAttempts,
    loadBoardData 
  } = useBoardStore();
  const [isImporting, setIsImporting] = useState(false);
  
  const handleExportJSON = () => {
    const boardState = {
      board_id: boardId,
      stickers,
      connectors
    };
    exportBoardToJSON(boardState);
  };

  const handleImportJSON = async () => {
    if (!isConnected) return;
    
    setIsImporting(true);
    try {
      const boardData = await importBoardFromJSON();
      loadBoardData(boardData);
      console.log('Board data imported successfully');
    } catch (error) {
      console.error('Import failed:', error.message);
      alert(`Import failed: ${error.message}`);
    } finally {
      setIsImporting(false);
    }
  };
  
  return (
    <div className="toolbar">
      <div className="toolbar-left">
        <div className="board-info">
          <span className="board-id">Board: {boardId}</span>
          <span className={`connection-status ${isConnected ? 'connected' : isReconnecting ? 'reconnecting' : 'disconnected'}`}>
            {isConnected 
              ? '🟢 Connected' 
              : isReconnecting 
                ? `🟡 Reconnecting... (${reconnectAttempts}/${maxReconnectAttempts})`
                : '🔴 Disconnected'
            }
          </span>
        </div>
      </div>
      
      <div className="toolbar-right">
        <button 
          className="import-button"
          onClick={handleImportJSON}
          disabled={!isConnected || isImporting}
        >
          {isImporting ? '⏳ Loading...' : '📁 Load from JSON'}
        </button>
        <button 
          className="export-button"
          onClick={handleExportJSON}
          disabled={!isConnected}
        >
          💾 Save to JSON
        </button>
      </div>
      
      <div className="toolbar-instructions">
        <span>Double-click to create • Drag to move • Blue circle for connections • Color circle to change color • Corner square to resize • Click arrow to select/delete</span>
      </div>
    </div>
  );
};

export default Toolbar;
